// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill' //用于实现浏览器不支持原生功能的代码
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from "element-ui"
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'element-ui/lib/theme-chalk/index.css'
import https from "@/config/fetch.js"
import "@/config/unit.js"
import Toast from "@/config/plugIn"

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper);
Vue.use(Toast);
Vue.prototype.$http = https;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js